import { LEGAL_VERSIONS } from '../constants/version';
import { LegalDocument, LegalDocumentType } from '../types/legalDocument';

export const manifesto: LegalDocument = {
  id: 'manifesto',

  title: 'MANIFESTO DA NEXORA',

  version: LEGAL_VERSIONS.manifesto,

  source: 'docs/legal/manifesto.md',

  documentType: 'manifesto' as LegalDocumentType,

  lastUpdated: 'Julho de 2026',

  effectiveDate: 'Julho de 2026',

  sections: [
    {
      id: 'organization-generates-freedom',

      title: 'Acreditamos que organização gera liberdade.',

      paragraphs: [
        {
          id: 'organization-generates-freedom-1',
          text: 'Vivemos uma era em que a informação cresce mais rápido do que nossa capacidade de organizá-la.',
        },

        {
          id: 'organization-generates-freedom-2',
          text: 'Prompts, ideias, documentos, fluxos de trabalho e conhecimentos importantes acabam espalhados entre aplicativos, arquivos e conversas, dificultando sua reutilização e evolução.',
        },

        {
          id: 'organization-generates-freedom-3',
          text: 'A Nexora nasceu para mudar essa realidade.',
        },
      ],
    },

    {
      id: 'mission',

      title: 'Nossa Missão',

      paragraphs: [
        {
          id: 'mission-1',
          text: 'Nossa missão é transformar conhecimento em um patrimônio organizado, seguro e escalável.',
        },

        {
          id: 'mission-2',
          text: 'Queremos que profissionais, equipes e empresas tenham um ambiente onde a inteligência construída ao longo do tempo permaneça acessível, protegida e pronta para evoluir.',
        },
      ],
    },

    {
      id: 'vision',

      title: 'Nossa Visão',

      paragraphs: [
        {
          id: 'vision-1',
          text: 'Acreditamos que a inteligência artificial não substitui pessoas.',
        },

        {
          id: 'vision-2',
          text: 'Ela potencializa pessoas organizadas.',
        },

        {
          id: 'vision-3',
          text: 'Nosso objetivo é construir uma plataforma que permita transformar conhecimento em processos consistentes, decisões mais rápidas e resultados melhores.',
        },

        {
          id: 'vision-4',
          text: 'Mais do que armazenar informações, queremos ajudar nossos usuários a desenvolver sistemas capazes de crescer continuamente.',
        },
      ],
    },

    {
      id: 'principles',

      title: 'Nossos Princípios',

      paragraphs: [],
    },

    {
      id: 'security-above-convenience',

      title: 'Segurança acima da conveniência',

      paragraphs: [
        {
          id: 'security-above-convenience-1',
          text: 'Toda funcionalidade deve respeitar a segurança da plataforma e de seus usuários.',
        },

        {
          id: 'security-above-convenience-2',
          text: 'A confiança é construída diariamente e protegida em cada decisão técnica.',
        },
      ],
    },

    {
      id: 'organization-as-competitive-advantage',

      title: 'Organização como vantagem competitiva',

      paragraphs: [
        {
          id: 'organization-as-competitive-advantage-1',
          text: 'Informações desorganizadas geram desperdício.',
        },

        {
          id: 'organization-as-competitive-advantage-2',
          text: 'Conhecimento organizado gera velocidade.',
        },

        {
          id: 'organization-as-competitive-advantage-3',
          text: 'A Nexora existe para transformar informação em estrutura.',
        },
      ],
    },

    {
      id: 'transparency-first',

      title: 'Transparência em primeiro lugar',

      paragraphs: [
        {
          id: 'transparency-first-1',
          text: 'Explicamos nossas regras.',
        },

        {
          id: 'transparency-first-2',
          text: 'Documentamos nossas decisões.',
        },

        {
          id: 'transparency-first-3',
          text: 'Mantemos nossos usuários informados.',
        },

        {
          id: 'transparency-first-4',
          text: 'Acreditamos que relações duradouras são construídas com clareza.',
        },
      ],
    },

    {
      id: 'continuous-evolution',

      title: 'Evolução contínua',

      paragraphs: [
        {
          id: 'continuous-evolution-1',
          text: 'A Nexora nunca será considerada pronta.',
        },

        {
          id: 'continuous-evolution-2',
          text: 'Cada melhoria representa um novo passo em direção a uma plataforma mais estável, inteligente e útil.',
        },

        {
          id: 'continuous-evolution-3',
          text: 'Evoluir faz parte da nossa essência.',
        },
      ],
    },

    {
      id: 'quality-before-speed',

      title: 'Qualidade antes da velocidade',

      paragraphs: [
        {
          id: 'quality-before-speed-1',
          text: 'Preferimos entregar uma funcionalidade sólida amanhã do que uma funcionalidade instável hoje.',
        },

        {
          id: 'quality-before-speed-2',
          text: 'Cada recurso desenvolvido deve contribuir para uma plataforma preparada para crescer durante muitos anos.',
        },
      ],
    },

    {
      id: 'commitment',

      title: 'Nosso Compromisso',

      paragraphs: [
        {
          id: 'commitment-1',
          text: 'Assumimos o compromisso de construir uma plataforma baseada em:',
        },

        {
          id: 'commitment-2',
          text: '* Segurança;',
        },

        {
          id: 'commitment-3',
          text: '* Organização;',
        },

        {
          id: 'commitment-4',
          text: '* Estabilidade;',
        },

        {
          id: 'commitment-5',
          text: '* Escalabilidade;',
        },

        {
          id: 'commitment-6',
          text: '* Transparência;',
        },

        {
          id: 'commitment-7',
          text: '* Respeito aos usuários.',
        },

        {
          id: 'commitment-8',
          text: 'Esses princípios orientam nossas decisões técnicas, administrativas e estratégicas.',
        },
      ],
    },

    {
      id: 'responsibility',

      title: 'Nossa Responsabilidade',

      paragraphs: [
        {
          id: 'responsibility-1',
          text: 'Sabemos que nossos usuários depositam na Nexora informações importantes para seus projetos e operações.',
        },

        {
          id: 'responsibility-2',
          text: 'Por isso, buscamos desenvolver um ambiente confiável, onde tecnologia e responsabilidade caminhem juntas.',
        },

        {
          id: 'responsibility-3',
          text: 'Cada nova funcionalidade deve preservar a integridade da plataforma e fortalecer a confiança construída com nossos usuários.',
        },
      ],
    },

    {
      id: 'community',

      title: 'Nossa Comunidade',

      paragraphs: [
        {
          id: 'community-1',
          text: 'A Nexora cresce junto com as pessoas que acreditam em seu propósito.',
        },

        {
          id: 'community-2',
          text: 'Valorizamos usuários que compartilham conhecimento, respeitam as regras da plataforma e contribuem para um ambiente colaborativo e profissional.',
        },

        {
          id: 'community-3',
          text: 'A comunidade faz parte da evolução da Nexora.',
        },
      ],
    },

    {
      id: 'future',

      title: 'O Futuro',

      paragraphs: [
        {
          id: 'future-1',
          text: 'Este manifesto não representa um ponto de chegada.',
        },

        {
          id: 'future-2',
          text: 'Representa um compromisso permanente.',
        },

        {
          id: 'future-3',
          text: 'Continuaremos evoluindo nossa tecnologia, nossos processos e nossa forma de servir nossos usuários, sempre guiados pelos mesmos princípios que deram origem à Nexora.',
        },
      ],
    },

    {
      id: 'message-to-users',

      title: 'Uma Mensagem aos Nossos Usuários',

      paragraphs: [
        {
          id: 'message-to-users-1',
          text: 'Obrigado por fazer parte desta jornada.',
        },

        {
          id: 'message-to-users-2',
          text: 'A confiança depositada em nossa plataforma é o que nos motiva a evoluir continuamente.',
        },

        {
          id: 'message-to-users-3',
          text: 'Esperamos que a Nexora seja mais do que uma ferramenta.',
        },

        {
          id: 'message-to-users-4',
          text: 'Esperamos que ela se torne uma extensão da organização, da criatividade e do conhecimento construído por cada usuário.',
        },

        {
          id: 'message-to-users-5',
          text: 'Seja bem-vindo à Nexora.',
        },
      ],
    },
  ],
};
